export default __webpack_public_path__ + "static/media/locasty-logo-full.ec12b1f7.svg";